(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.hero--parallax');
    if (!sections.length) return;

    const updateParallax = () => {
      const vh = window.innerHeight || 1;

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const media = section.querySelector('.hero__media-wrapper');
        if (!media) return;

        const strength = parseFloat(
          getComputedStyle(section).getPropertyValue('--hero-parallax-strength')
        ) || 0.35;

        // How far the section is from the center of the screen (-1 to 1-ish)
        const progress = (rect.top + rect.height / 2 - vh / 2) / vh;

        // Parallax offset (px)
        const offset = -progress * strength * vh;

        media.style.transform = `translate3d(0, ${offset}px, 0)`;
      });
    };

    updateParallax();
    document.addEventListener('scroll', updateParallax, { passive: true });
    window.addEventListener('resize', updateParallax);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
